import Vue from 'vue'
import Router from 'vue-router'
import Wallboards from './views/Wallboards.vue'
import Login from './views/Login.vue'
import Wallboard from './views/Wallboard.vue'
import auth from './utils/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/wallboards',
      name: 'wallboards',
      component: Wallboards,
      meta: {
        requiresAuth: true
      }
    },
    { path: '/wallboards/:id', component: Wallboard, meta: { requiresAuth: true } },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      redirect: '/wallboards'
    }
  ]
})

// router.replace({ path: 'wallboards', redirect: '/' })
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isAuthenticated()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router